<div class="row">
    <div class="col-12">
        <div id="billingList" class="card">
            <app-list-layout [tableConfig]="tableConfig" [defaultTableConfig]="defaultTableConfig"  [listItems]="listItems"
                [listService]="billingListService" (buttonActionSelected)="buttonActionSelected($event)"
                (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
                (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
                (searchTermChanged)="billingListService.searchTerm = $event"
                (dateRangeChanged) = "billingListService.rangeDate = $event"
                (resetListLayout) = "billingListService.resetListState($event)"
                (updateListConfig)="updateListConfig($event)"
                (paginationSelected)="paginationUpdated(billingListService,$event)" [serviceData]="serviceData"
                (pageSizeSelected)="billingListService.pageSize = $event"></app-list-layout>
        </div>
    </div>
</div>